module.exports = __webpack_public_path__ + "img/040.2a0e9a8a.png";